/**
 * Fisheye
 */
export var Fisheye = function Fisheye(_ref) {
  var _ref$focusX = _ref.focusX,
    focusX = _ref$focusX === void 0 ? 0 : _ref$focusX,
    _ref$focusY = _ref.focusY,
    focusY = _ref$focusY === void 0 ? 0 : _ref$focusY,
    _ref$distortionX = _ref.distortionX,
    distortionX = _ref$distortionX === void 0 ? 2 : _ref$distortionX,
    _ref$distortionY = _ref.distortionY,
    distortionY = _ref$distortionY === void 0 ? 2 : _ref$distortionY,
    _ref$visual = _ref.visual,
    visual = _ref$visual === void 0 ? false : _ref$visual;
  return [['fisheye', focusX, focusY, distortionX, distortionY, visual]];
};
Fisheye.props = {
  transform: true
};